import {createApp} from 'vue';
import {safeDefine} from '@breuni-ui/safe-define';
import vueDataVueComponent from './vueData.vue.component';
import '../../scripts/lib/EventBus.js';
import {readJsonFromDom} from '../../scripts/utils.js';

class BewertenVueData extends HTMLElement {
  connectedCallback() {
    const appRoot = document.querySelector('#ents-vue-pds');
    const productJSON = readJsonFromDom('#entsProductData');
    const {
      syan,
      articles,
      articleKey: initialKey,
    } = productJSON;
    const productDetailsJSON = readJsonFromDom('#entsProductDetailData');
    const eventTrackingJSON = readJsonFromDom('#entsEventTrackingData');
    const metaLanguageJSON = readJsonFromDom('#entsLanguageMetaData');
    const {
      mandatedHost,
      wishlistApiTimeout: rawWishlistApiTimeout,
      fitaRecoCall: rawFitaRecocall,
      showChristmasBear: rawShowChristmasBear,
      isBreuningerReferrer: rawIsBreuningerReferrer
    } = this.dataset;
    const wishlistApiTimeout = parseInt(rawWishlistApiTimeout, 10);
    const fitaRecoCall = rawFitaRecocall === 'true';
    const showChristmasBear = rawShowChristmasBear === 'true';
    const isBreuningerReferrer = rawIsBreuningerReferrer === 'true';

    const app = createApp(
      vueDataVueComponent({
        syan,
        articles,
        initialKey,
        productJSON,
        productDetailsJSON,
        eventTrackingJSON,
        metaLanguageJSON,
        appRoot,
        mandatedHost,
        wishlistApiTimeout,
        fitaRecoCall,
        showChristmasBear,
        isBreuningerReferrer
      }),
    );

    // configureCompat({ RENDER_FUNCTION: false, COMPILER_INLINE_TEMPLATE: true });
    app.config.compilerOptions.whitespace = 'preserve';
    app.config.compilerOptions.delimiters = ['[[', ']]'];
    app.config.compilerOptions.isCustomElement =
      tag => /^shop-|^bewerten-|^ents-|^suchen-|^kaufen-|^entd-|^brtn-|^camp-|^reco-|^additional-price-info|^loyl-|^klarna-placement/.test(tag);

    app.mount(appRoot);
  }
}

safeDefine('ents-vue-data', BewertenVueData);
